import React, { useEffect, useRef, useState } from "react";

import Footer from './Footer.jsx';

const RevealOnScroll = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);
  
    useEffect(() => {
      let observerRefValue = null;
      const scrollObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            scrollObserver.unobserve(entry.target);
          }
        },
      );
  
      scrollObserver.observe(ref.current);
      observerRefValue = ref.current;
  
      return () => {
        if (observerRefValue) {
          scrollObserver.unobserve(observerRefValue);
        }
      };
    }, []);
    
    const classes = `transition-opacity duration-1500 ${
      isVisible ? 'opacity-100' : 'opacity-0'
    }`;
  
    return (
      <div ref={ref} className={classes}>
        {children}
      </div>
    );
};

const Products = () => {


    return (
        <div className="min-h-screen bg-lime-200 bg-opacity-50 text-lime-800 relative">
            {/* Header */}
            <header className="relative pt-40 transition-all duration-500 ease-in-out">
                <RevealOnScroll>
                    <div className="flex flex-col items-center mx-auto relative z-10">
                        <div className="flex flex-col md:text-8xl text-6xl font-semibold">
                            <h1 className="">Products</h1>
                        </div>
                    </div>
                </RevealOnScroll>
            </header>

            {/* Main Content */}
            <main className="flex flex-col items-center justify-center mx-auto px-10 transition-all duration-500 ease-in-out">

                {/* Neumorphic Design */}
                <div className="flex flex-col my-4 md:p-8 md:w-1/2">
                    <div className="md:px-10">
                        <RevealOnScroll>
                            <p className="text-left md:text-center md:text-2xl text-xl mt-4 lg:px-40 md:px-20">
                                Need inspiration? Find some eligible products below. 
                            </p>
                        </RevealOnScroll>
                    </div>
                </div>

                {/* First body part */}
                <div className="flex flex-row items-center justify-center w-screen my-4 p-4 md:p-8">
                <div className="flex flex-col gap-2 w-screen md:w-1/2 justify-start transition-all duration-500 ease-in-out p-5 shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded-lg ">
                    <h3 className="text-2xl font-semibold">Coming Soon (Aloe is still early access)!</h3>
                    <p className="text-l">Cool product description here...</p>
                </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Products;
